var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentiment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5225 10.4679C22.6497 9.52134 21.4522 9 20.1502 9C19.1769 9 18.2856 9.30769 17.501 9.91444C17.1051 10.2207 16.7463 10.5954 16.43 11.0328C16.1138 10.5955 15.7549 10.2207 15.3589 9.91444C14.5744 9.30769 13.6831 9 12.7098 9C11.4078 9 10.2101 9.52134 9.33738 10.4679C8.47504 11.4035 8 12.6816 8 14.0669C8 15.4928 8.53138 16.798 9.67221 18.1747C10.6928 19.406 12.1596 20.6561 13.8581 22.1036C14.4381 22.5979 15.0956 23.1582 15.7782 23.7551C15.9586 23.913 16.19 24 16.43 24C16.6699 24 16.9014 23.913 17.0815 23.7553C17.7642 23.1584 18.422 22.5978 19.0023 22.1032C20.7006 20.656 22.1674 19.406 23.1879 18.1745C24.3288 16.798 24.86 15.4928 24.86 14.0668C24.86 12.6816 24.385 11.4035 23.5225 10.4679Z",
    fill: "#408C88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentiment);
export default __webpack_public_path__ + "static/media/Sentiment.b0098d4f892f99cb098d78247eca3d55.svg";
export { ForwardRef as ReactComponent };